module.exports = __webpack_public_path__ + "static/media/GoldmanSachs-logo.f7dcaf63.png";